import React from "react";
import { Space, Tag } from "antd";
import { BankOutlined } from "@ant-design/icons";
import {
  formatMoney,
  formatAccountNumber,
  formatDateTime,
} from "../../utils/formatUtils";

export function renderBankCell(value) {
  return (
    <Space size={10}>
      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 text-slate-600">
        <BankOutlined />
      </div>
      <span className="font-medium text-slate-800">{value || "-"}</span>
    </Space>
  );
}

export function renderAccountNumberCell(value) {
  return (
    <span className="font-mono text-slate-700">
      {value ? formatAccountNumber(value) : "-"}
    </span>
  );
}

export function renderCurrencyCell(value) {
  return (
    <Tag className="rounded-lg border-0 bg-slate-100 px-3 py-1 text-slate-700">
      {value || "-"}
    </Tag>
  );
}

export function renderDateTimeCell(value) {
  return <span className="text-slate-500">{formatDateTime(value)}</span>;
}

export function renderMoneyCell(value, record) {
  return (
    <span className="font-semibold text-slate-900">
      {formatMoney(value, record?.currency)}
    </span>
  );
}

export function getBankColumn() {
  return {
    title: "Банк",
    dataIndex: "bank",
    key: "bank",
    width: 300,
    render: renderBankCell,
  };
}

export function getAccountNumberColumn() {
  return {
    title: "Дансны дугаар",
    dataIndex: "accountNumber",
    key: "accountNumber",
    width: 240,
    render: renderAccountNumberCell,
  };
}

export function getCurrencyColumn() {
  return {
    title: "Валют",
    dataIndex: "currency",
    key: "currency",
    width: 120,
    align: "center",
    render: renderCurrencyCell,
  };
}

export function getBalanceUpdatedColumn() {
  return {
    title: "Жинхэнэ үлдэгдэл шинэчлэгдсэн",
    dataIndex: "balanceUpdatedAt",
    key: "balanceUpdatedAt",
    width: 180,
    align: "center",
    render: renderDateTimeCell,
  };
}

export function getWalletUpdatedColumn() {
  return {
    title: "Хийсвэр үлдэгдэл шинэчлэгдсэн",
    dataIndex: "walletBalanceUpdatedAt",
    key: "walletBalanceUpdatedAt",
    width: 180,
    align: "center",
    render: renderDateTimeCell,
  };
}

export function getTotalBalanceColumn() {
  return {
    title: "Жинхэнэ үлдэгдэл",
    dataIndex: "balance",
    key: "balance",
    width: 160,
    align: "center",
    render: renderMoneyCell,
  };
}

export function getWalletBalanceColumn() {
  return {
    title: "Хийсвэр үлдэгдэл",
    dataIndex: "walletBalance",
    key: "walletBalance",
    width: 160,
    align: "center",
    render: renderMoneyCell,
  };
}